import { render, staticRenderFns } from "./DoublesTab.vue?vue&type=template&id=bd0ccc6e&scoped=true"
import script from "./DoublesTab.vue?vue&type=script&lang=js"
export * from "./DoublesTab.vue?vue&type=script&lang=js"
import style0 from "./DoublesTab.vue?vue&type=style&index=0&id=bd0ccc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ccc6e",
  null
  
)

export default component.exports